"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RankingActionEnum;
(function (RankingActionEnum) {
    RankingActionEnum["BOOST"] = "BOOST";
    RankingActionEnum["BURY"] = "BURY";
})(RankingActionEnum = exports.RankingActionEnum || (exports.RankingActionEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFua2luZy1hY3Rpb24uZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9yYW5raW5nLWFjdGlvbi5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBWSxpQkFHWDtBQUhELFdBQVksaUJBQWlCO0lBQzNCLG9DQUFlLENBQUE7SUFDZixrQ0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQUhXLGlCQUFpQixHQUFqQix5QkFBaUIsS0FBakIseUJBQWlCLFFBRzVCIn0=